<template lang='pug' src='./NotFound.pug'></template>

<script>
  export default {
    name: 'NotFound'
  }
</script>

<style lang='css' src='./NotFound.css'></style>



// WEBPACK FOOTER //
// NotFound.vue?7205f74f